import { Component } from "react"; 
import MUIDataTable from 'mui-datatables'
import React from 'react';
import ExpandableRow from "./ExpandableRow";
import ToolbarSelected from "./ToolbarSelected";
import axiosInstance from "../../axiosInstance";
import { containsPermission, logOut } from "../helper";
import { withRouter } from "react-router-dom";
import {Modal,Button } from "react-bootstrap";
import { ThreeSixty } from "@material-ui/icons";

 const primaryColumns = [
  {
      "name" : "account_id",
      "label" : "საბილინგო ნომერი",
      "options":{
          "sort" :false
      }
    }
  ,
  {
      "name" : "type",
      "label" : "ტიპი",
      "options":{
          "sort" :false
      }
  },
  {
    "name" : "provider",
    "label" : "პროვაიდერი",
    "options":{
        "sort" :false
    }
  },
  {
    "name" : "address",
    "label" : "მისამართი"
  },
  {
      "name" : "status",
      "label" : "სტატუსი",
      "options":{
          "sort" :false,
          setCellProps: (value) => {
            var backgroundColor = "#34eb52";
            var color = "white";

            if(value ==="მიმდინარე")backgroundColor = "#deb500";
            if(value === 'წარმატებით დახურული')backgroundColor = "#76b502";
            if(value === 'გადადებული')backgroundColor = "rgb(181, 104, 80)";
            if(value === 'წარუმატებლად დახურული'){
                backgroundColor = "#d93425";
            }
            if(value === 'დახურული')backgroundColor = "#1aba5a";
            return {   
            style: {
                        "backgroundColor": backgroundColor,
                        "color":color,
                        // "textAlign":"center"
                }
            };
        },
      }
  },
  {
      "name" : "stage",
      "label" : "მდგომარეობა",
      "options":{
          "sort" :false
      }
  },
  
  // {
  //     "name" : "problem",
  //     "label" : "პრობლემა",
  //     "options":{
  //         "sort" :true
  //     }
  // },
  {
      "name" : "created_at",
      "label" : "გახსნის თარიღი",
      "options":{
          "sort" :true
      }
  },
  {
      "name" : "closed_at",
      "label" : "დახურვის თარიღი",
      "options":{
          "sort" :true
      }
  },
];

 const secondary_columns = [
  {
      "name" : "personal_number",
      "label" : "პირადი ნომერი"
  },
  {
      "name" : "first_name",
      "label" : "სახელი"
  },
  {
      "name" : "second_name",
      "label" : "გვარი"
  },
  {
      "name" : "city",
      "label" : "ქალაქი"
  },
  {
      "name" : "phone",
      "label" : "მობილური (1)",
      "options":{
          "sort" :false
      }
  },
  {
    "name" : "second_phone",
    "label" : "მობილური (2)",
    "options":{
        "sort" :false
    }
  },
  {
    "name" : "quantity",
    "label" : "რაოდენობა",
    "options":{
        "sort" :false
    }
},

  {
      "name" : "internet_speed",
      "label" : "OTT ინტერნეტის სიჩქარე"
  },
  {
    "name" : "internet_provider",
    "label" : "OTT ინტერნეტ პროვაიდერი"
  },
];

class MuiTable extends Component{
  _isMounted = false;


    constructor(props){
      super(props)
      this.binds();
      this.tableRef =  React.createRef();
      this.state = {
        primary_columns:[],
        secondary_columns:[],
        data:[],
        showModal:false,
        searchQuery:"",
        numberOfRows:10,
        currentPage:0,
        sort:{
          column:"created_at",
          direction:"desc"
        },
        options:{
          serverSide:true,
          filterType: 'checkbox',
          expandableRows:true,
          selectableRowsHeader:false,
          expandableRowsHeader:false,
          viewColumns:false,
          print:false,
          filter:false,
          selectableRows:'single',
          count:20,
          rowsSelected:[],
          rowsExpanded:[],
          pagination:true,
          customToolbarSelect:this.toolbarSelect,
          onSearchChange:this.search,
          // customSearch:this.search,
          renderExpandableRow: this.renderExpandableRow,
          onChangeRowsPerPage:this.onChangeRowsPerPage,
          onChangePage:this.onChangePage,
          onColumnSortChange:this.onColumnSortChange,
          onRowSelectionChange:this.onRowSelectionChange,
          onRowClick:this.onRowClick,
          isRowSelectable:this.isRowSelectable
        }
      }

      this.wrapper = React.createRef();
    }

    componentDidMount(){
      this._isMounted = true;
      this.fetchData();
      this.interval = setInterval(
        () => this.fetchData(),
      300000); 
    }

    binds(){
      this.onChangePage = this.onChangePage.bind(this);
      this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this);
      this.onColumnSortChange = this.onColumnSortChange.bind(this);
      this.renderExpandableRow = this.renderExpandableRow.bind(this);
      this.search = this.search.bind(this);
      this.toolbarSelect = this.toolbarSelect.bind(this);
      this.fetchData = this.fetchData.bind(this);
      this.onRowClick = this.onRowClick.bind(this);
      this.update_table = this.update_table.bind(this);
    }


    
    onRowClick(rowData, rowMeta){
      if(containsPermission(this.props.role_permissions,'ticket_logs.see')){
        let ticket_id = this.state.data[rowMeta.dataIndex].id;
        this.props.history.push("/ticket/logs/"+ticket_id);
      }
      
    }
    onColumnSortChange(changedColumn, direction){
      if(this._isMounted){
        this.setState({
          sort:{
            column:changedColumn,
            direction:direction
          }
        });
      }
    }
    onChangePage(currentPage){
      if(this._isMounted){
        this.setState({
          currentPage:currentPage
        })
      }
    }
    onChangeRowsPerPage(numberOfRows){
      if(this._isMounted){
        this.setState({
          numberOfRows:numberOfRows
        })
      }
    }

    renderExpandableRow(rowData, rowMeta){
      return (<ExpandableRow ref = {this.wrapper} data = {this.state.data[rowMeta.dataIndex]} onComment = {this.comment} columns = {secondary_columns}/>)
    }
    search(searchQuery){
      if(this._isMounted){
        this.setState({
          searchQuery:searchQuery,
          currentPage:0
        });
      }
      return true
    }

    update_table(){
      this.setState({
        options:{
          ...this.state.options,
          rowsSelected:[]
        }
      })
      this.fetchData();
    }

    toolbarSelect(selectedRows, displayData, setSelectedRows){
      return <ToolbarSelected 
        data = {this.state.data[selectedRows.data[0].dataIndex]} 
        role = {1} 
        updateTable = {this.update_table}  
        role_permissions = {this.props.role_permissions} />
    }



    on_fetch_data(data){
      if(this._isMounted){
        this.setState({
          data:data[1],
          options:{
            ...this.state.options,
            count:data[0],
            rowsSelected:[]
          }
        })
      }
    }

    fetchData(){
      axiosInstance.get('/tickets/dashboard',{
        params: {
          status_id: this.props.status_filter,
          type_id:this.props.type_filter,
          stage_id:this.props.stage_filter,
          search_query:this.state.searchQuery,
          current_page:this.state.currentPage,
          number_of_rows:this.state.numberOfRows,
          sort_column:this.state.sort.column,
          sort_direction:this.state.sort.direction,
          date_from : this.props.date_from,
          date_to : this.props.date_to
        }
      }).then(response=>{
        this.setState({
          data:response.data.data.tickets,
          options:{
            ...this.state.options,
            count:response.data.data.count,
            rowsSelected:[]
          }
        })
      })
        .catch(err => {
          if(err.response){
            if(err.response.status === 401){
              logOut(this.props);
            }
          }
          console.log(err)  
        })
    }
    componentWillUnmount(){
      this._isMounted = false;
    }


    state_not_equal(prevState){
      if(this.state.numberOfRows !== prevState.numberOfRows || 
          this.state.currentPage !== prevState.currentPage ||
          this.state.sort.column !== prevState.sort.column ||
          this.state.sort.direction !== prevState.sort.direction||
          this.state.searchQuery !== prevState.searchQuery
          ){
            return true
      }
      return false;
    }


    props_changed(prevProps,prevState){
      if(prevProps.type_filter !== this.props.type_filter ||
         prevProps.status_filter !== this.props.status_filter ||
         prevProps.stage_filter !== this.props.stage_filter ||
         prevProps.date_from !== this.props.date_from ||
         prevProps.date_to !== this.props.date_to
         ){
        return true;
      }
      return false;
    }
    componentDidUpdate(prevProps, prevState){
      if(this.props_changed(prevProps) && prevState.currentPage !==0){
        this.tableRef.current.changePage(0)
        return;
      }
      if(this.props_changed(prevProps,prevState)||this.state_not_equal(prevState))
      {
        this.fetchData();
      }
    }

    


    render(){

      return(
        <div>
          
          <MUIDataTable
        innerRef={this.tableRef}
        ref = {this.wrapper}
        title={"ცხრილი"}
        data={this.state.data}
        columns={primaryColumns}
        options={this.state.options}
      />
        </div>
      )
       
    }
}

export default withRouter(MuiTable); 